import { useSelector } from "react-redux";

import { DealProvider } from "context/DealContext";
import { getUserPrefersMedical } from "redux/selectors/user";
import { MENU_TITLES } from "utils/menuTypeUtils";

import ActiveDealsCarousel from "components/Dispensary/ActiveDealsCarousel";
import CategoryCarousel from "components/Dispensary/CategoryCarousel";
import LastUpdatedTime from "components/Dispensary/LastUpdatedTime";
import MedicalInfo from "components/Dispensary/MedicalInfo";
import PhenotypeCarousel from "components/Dispensary/PhenotypeCarousel";
import ProductRecTrays from "components/Dispensary/ProductRecTrays";
import PromotedBrandCarousel from "components/Dispensary/PromotedBrandCarousel";
import SearchBar from "components/Dispensary/SearchBar";
import ShopAllButton from "components/Dispensary/ShopAllButton";
import StaffPicksCarousel from "components/Dispensary/StaffPicksCarousel";
import RecentlyViewedMenuItems from "components/Shared/RecentlyViewedMenuItems";

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  deals: any;
  isDualMenuDispensary: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  slug: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  sortedCategories: any;
  state?: string;
};

const PaidTierMenu: React.FC<Props> = ({
  deals,
  isDualMenuDispensary,
  slug,
  sortedCategories,
  state,
}) => {
  const hideCategoryCoins = state === "AB";

  const userPrefersMedical = useSelector(getUserPrefersMedical);
  const medRecPreference = userPrefersMedical
    ? MENU_TITLES.med.shortTitle
    : MENU_TITLES.rec.shortTitle;

  return (
    <div className="bg-white pt-xl">
      <DealProvider
        slug={slug}
        initialState={deals ? { data: deals } : undefined}
      >
        <div className="container">
          <MedicalInfo currentMenuType={medRecPreference} />

          <SearchBar
            className="mt-xl mb-lg"
            routeToMenu
            isDualMenuDispensary={isDualMenuDispensary}
          />

          <LastUpdatedTime className="mb-lg" />

          {!hideCategoryCoins && <CategoryCarousel className="mb-section" />}
          <PromotedBrandCarousel
            className="mb-section"
            currentMenuType={medRecPreference}
          />
          <RecentlyViewedMenuItems
            className="mb-section"
            attributes={{ dispensarySlug: slug }}
            isDualMenuDispensary={isDualMenuDispensary}
            currentMenuType={medRecPreference}
          />
        </div>

        <ActiveDealsCarousel
          cardsPerSlide={4}
          showBackground
          dealCardLinks
          isDualMenuDispensary={isDualMenuDispensary}
          currentMenuType={medRecPreference}
        />

        <div className="container">
          <StaffPicksCarousel className="mb-section" />
          <ProductRecTrays
            slug={slug}
            categories={sortedCategories.slice(0, 1)}
            isDualMenuDispensary={isDualMenuDispensary}
            currentMenuType={medRecPreference}
          />
          {!hideCategoryCoins && <PhenotypeCarousel className="mb-section" />}
          <ProductRecTrays
            slug={slug}
            categories={sortedCategories.slice(1)}
            isDualMenuDispensary={isDualMenuDispensary}
            currentMenuType={medRecPreference}
          />
          <ShopAllButton className="mb-section" />
        </div>
      </DealProvider>
    </div>
  );
};
export default PaidTierMenu;
